import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useUpdateIndeedFlexCompanyMutation } from 'queries/admin/indeedFlex/useUpdateIndeedFlexCompanyMutation'

type EditIndeedFlexCompanyFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useUpdateIndeedFlexCompanyMutation>['mutate']
    reset: ReturnType<typeof useUpdateIndeedFlexCompanyMutation>['reset']
  }
}

const [Context, useEditIndeedFlexCompanyFlowContextValue] =
  createContext<EditIndeedFlexCompanyFlowContextState>({
    name: 'EditIndeedFlexCompanyFlowContext',
  })

export const EditIndeedFlexCompanyFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const { mutate, reset, isPending, isError, error } =
    useUpdateIndeedFlexCompanyMutation()

  const value: EditIndeedFlexCompanyFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useEditIndeedFlexCompanyFlowContextValue }
